import { getDayName } from 'common/formatters';
import React from 'react';

const schedule = [
    { startDay: 1, startTime: '7:45am', endDay: 1, endTime: '6pm', type: 'Day' },
    { startDay: 1, startTime: '6pm', endDay: 2, endTime: '7:45am', type: 'Night' },
    { startDay: 2, startTime: '7:45am', endDay: 2, endTime: '6pm', type: 'Day' },
    { startDay: 2, startTime: '6pm', endDay: 3, endTime: '7:45am', type: 'Night' },
    { startDay: 3, startTime: '7:45am', endDay: 3, endTime: '6pm', type: 'Day' },
    { startDay: 3, startTime: '6pm', endDay: 4, endTime: '7:45am', type: 'Night' },
    { startDay: 4, startTime: '7:45am', endDay: 4, endTime: '6pm', type: 'Day' },
    { startDay: 4, startTime: '6pm', endDay: 5, endTime: '7:45am', type: 'Night' },
    { startDay: 5, startTime: '7:45am', endDay: 5, endTime: '6pm', type: 'Day' },
    { startDay: 5, startTime: '6pm', endDay: 1, endTime: '7:45am', type: 'Night' }
]

const CommodityLimitSchedule: React.FC<any> = props => {
    return <><h4>Session Schedule</h4>
        <table className="table table-striped">
            <thead>
                <tr>
                    <th>Start Day</th>
                    <th>Start Time (CST)</th>
                    <th>End Day</th>
                    <th>End (CST)</th>
                    <th>Type</th>
                </tr>
            </thead>
            <tbody>
                {schedule.map((m, i) => 
                    <tr key={i}>
                        <td>{getDayName(m.startDay)}</td>
                        <td>{m.startTime}</td>
                        <td>{getDayName(m.endDay)}</td>
                        <td>{m.endTime}</td>
                        <td>{m.type}</td>
                    </tr>
                )}
            </tbody>
        </table>
    </>;
}

export default CommodityLimitSchedule;